export default {
    tms: {

    },
    generic: {
        Home:"홈페이지",
        ReporMaster: "Report Master",
        GenericName: "일반 이름",
        ModuleCode: "모듈 코드",
        Description: "설명",
        FunctionCode: "기능 코드",
        PageTitleCode: "페이지 제목 코드",
        IsPaging: "페이징 여부",
        IgnoreCount: "이전/다음 페이지",
        Creator: "생성자",
        CreateDate: "생성 날짜",
        Modifier: "수정자",
        ModifyDate: "수정 날짜",
        GMCUID: "GMC UID",
        SCHEMAUID: "SCHEMA UID",
        UIAction: "UI 액션",
        Validation: "검증",
        Editable: "편집 가능",
        EditCondition:"조건 편집",
        Searchable: "검색 가능",
        DefaultValue: "기본 값",
        Madatory: "필수",
        Displayable: "표시 가능",
        Sequence: "시퀀스",
        Condition: "조건",
        Mandatory: "필수",
        AndOr: "그리고 또는",
        GCDUID: "GCD UID",
        ParentGCDUID: "부모 GCD UID",
        IfOrNotMove: "이동 작업이 필요합니까?",
        TableName: "테이블 이름",
        EnglishName: "영문 명칭",
        CnName: "중국어 명칭",
        TraditionalCNName: "중국어 번체자 명칭",
        KorName: "한국어 명칭",
        thName: "태국어",
        jpName: "일본어",
        Header: "메인 정보",
        TableAlias: "테이블 별칭",
        FieldName: "필드 이름",
        FieldType: "필드 유형",
        FieldLength: "필드 길이",
        FieldLengthDecimal: "필드 길이 소수점",
        ForeignTable: "외래 테이블",
        ForeignFIELD: "외래 필드",
        LanguageCode: "언어 코드",
        Module: "모듈",
        SubPage: "하위 페이지",
        SubModule: "하위 모듈",
        Function: "기능",
        PageTitle: "페이지 제목",
        Decimal: "소수점",
        Edit: "편집",
        Add: "추가",
        More: "더",
        AreyoudeleTask: "선택한 레코드를 삭제하겠습니까?",
        Yes: "예",
        No: "아니오",
        Delete: "삭제",
        Zip: "압축 Zip",
        Up: "위로",
        Down: "아래로",
        Store: "저장",
        ButtonGroupName: "버튼 그룹 이름",
        Apply: "적용",
        Configuration: "설정",
        Name: "이름",
        RenderType: "렌더링 유형",
        Type: "유형",
        Code: "코드",
        ViewType: "뷰 유형",
        PatternType: "패턴 유형",
        ExtenalAPI: "외부 API",
        MapToModule: "모듈 맵핑",
        FieldMap: "필드 맵핑",
        BehaviorPattern: "행동 패턴",
        Parameters: "파라미터",
        CustPage: "CustPage",
        Action: "액션",
        Width: "너비",
        ConsParameter: "Cons. 파라미터",
        Constrainttable: "제약 테이블",
        Seq: "시퀀스",
        ValidationSQL: "검증 SQL",
        operate: "운영",
        Group: "그룹",
        FKTable: "외래 키 테이블",
        FKFieldName: "외래 키 필드 이름",
        SQLParameters: "SQL 파라미터",
        defaultValue: "기본 값",
        DisplayColumns: "표시 열",
        SortSeq: "정렬 시퀀스",
        OrderBy: "정렬 기준",
        Refresh: "새로 고침",
        PagePropertyGroupName: "페이지 속성 그룹 이름",
        Disaplyable: "표시 가능",
        Like: "흐릿한",
        IsShowTitle: "제목 표시 여부",
        ShowTitleSeq: "제목 표시 시퀀스",
        OptionType: "옵션 유형",
        ExtentionValue: "확장 값",
        GenIdtype: "Gen Id 유형",
        Hyperlink: "하이퍼링크",
        Isitunique: "고유한가?",
        Statistics: "통계",
        DataFormat: "데이터 형식",
        FieldPattern: "필드 패턴",
        GenericParameters: "제네릭 파라미터",
        DefaultSelected: "기본 선택",
        IsReserveAdmin: "관리자 예약 여부",
        TitleInfo: "제목 정보",
        UniqueParameter: "유일한 파라미터",
        Depend: "의존",
        IsDefType: "IsDefType",
        ConfigurationMethod: "설정 방법",
        CalcParameters: "계산 파라미터",
        CalcType: "계산 유형",
        SurfixParameter: "접미사 파라미터",
        ComputationalEvent: "계산 이벤트",
        TriggerFields: "트리거 필드",
        IsTrigger: "트리거 여부",
        Publish: "게시",
        AdvanceSearch: "고급 검색",
        SearchTemplate: "검색 템플릿",
        IsDefault: "기본 여부",
        Loadable: "로드 가능",
        IsExtra: "추가 여부",
        ExtraParameters: "추가 파라미터",
        TemplateName: "템플릿 이름",
        CreateTime: "생성 시간",
        Copy: "복사",
        CreateGenericData: "일반 데이터 생성",
        AppendGenericData: "일반 데이터 추가",
        DeleteGenericData: "일반 데이터 삭제",
        PleasemoduleonlyGeneric: "모듈당 하나의 기본 데이터만 있는지 확인하십시오",
        DBSchema: "DB 스키마",
        PageProperty: "페이지 속성",
        SQL: "SQL",
        ConfigSQL: "SQL 설정",
        Behavior: "행동",
        ForOption: "옵션을 위해",
        StartupModule: "시작 모듈",
        UseViewSQL: "뷰 SQL 사용",
        ReportView: "보고서 뷰",
        TableViewName: "테이블/뷰 이름",
        FiledName: "필드 이름",
        Basic: "기본",
        AliasName: "별칭",
        SubModuleCode: "하위 모듈 코드",
        SubModuleName: "하위 모듈 이름",
        FunctionName: "기능 이름",
        FunctionLevel: "기능 레벨",
        ParentFunctionCode: "상위 기능 코드",
        FunctionSeq: "기능 시퀀스 번호",
        FunctionURL: "기능 URL",
        LangCode: "언어",
        Menu: "메뉴",
        GenericMenu: "Generic Menu",
        RelationTable: "연관표",
        UserMenu: "User Menu",
        FunctionAPI: "기능 API",
        Status: "박스상태",
        NotInactive: "이미 게시되었거나 비활성화된 구성을 삭제할 수 없습니다",
        Mapto: "매핑 대상",
        Project: "프로젝트",
        Usage: "사용",
        Source: "소스",
        TargetTo: "타겟 투",
        ExcelType: "Excel 유형",
        OnlyAllowLetter: "문자만 입력 가능",
        Export: "내보내기",
        SourceMap: "소스 매핑",
        MapToView: "뷰 매핑",
        TargetMap: "타겟 매핑",
        Excel: "Excel",
        SelectedMatched: "선택한 열은 일치해야 합니다.",
        DataDuplication: "데이터 중복",
        UnUploadFile: "파일을 업로드하십시오!",
        isShowCopy:"복제",
        copySuccess:"복사에 성공했습니다",
        totalOf:"총계 ",
        Records:"기록",
    },
    userlang: {
        Address1: "주소1",
        Address2: "주소2",
        Address3: "주소3",
        Address4: "주소4",
        Postal: "우편번호",
        Street: "거리",
        District: "지구",
        Latitude: "위도",
        Longitude: "경도",
        Country: "국가",
        Enable: "활성화",
        Disable: "비활성화",
        Empower: "권한 부여",
        Edit: "편집",
        EditUser: "사용자 편집",
        UserAccount: "사용자 계정",
        LoginAccount: "사용자 계정",
        DispName:"사용자 이름",
        Email: "이메일",
        EmailInfoFrom: "입력한 이메일이 유효하지 않습니다!",
        FirstName: "이름",
        MiddleName: "중간 이름",
        LastName: "성",
        DisplayName: "표시 이름",
        Title: "제목",
        Gender: "성별",
        Male: "남성",
        Female: "여성",
        Company: "회사",
        Department: "부서",
        Position: "직책",
        Telephone: "전화",
        City: "도시",
        SelectCity: "도시 선택",
        TimeZone: "시간대",
        Language: "언어",
        english:"영어",
        Jtlang: "중국어 간체",
        ftlang: "중국어 번체",
        englishName:"영어 이름",
        sumplifiedName:"단순화된 이름",
        traditionalName:"전통적인 이름",
        koreanName:"영어 이름",
        japaneseName:"일본어 이름",
        thaiName:"태국어 이름",
        korlang: "한국어",
        thlang: "ภาษาไทย",
        jplang: "日本語",
        Orgnization: "조직",
        Project: "프로젝트",
        Delete: "삭제",
        NorecordFound: "기록을 찾을 수 없음",
        Organization: "조직",
        Warehouse: "창고",
        WarehouseName: "창고명",
        Address: "주소",
        Save: "박스 저장",
        AccessRights: "액세스 권한",
        Pleaseselect: "선택해주세요",
        Role: "역할",
        PleaseOneleast: "최소한 하나를 선택해주세요.",
        SaveSuccessfully: "성공적으로 저장됨",
        AddProject: "프로젝트 추가",
        AddWarehouse: "창고 추가",
        defaultOrg:"기본 조직",
        defaultProj:"기본 항목",
        domain:"도메인",
        useredQr:"2FA 사용자 QR"
    },
    convertCountResult: {
        title: "재고 변환 결과",
        filenameStartFrom: "파일명 시작 문자",
        importSuccess: "업로드 성공",
        pleaseUpload: "파일을 업로드해 주세요",
        noFileToDownload: "다운로드할 파일이 없습니다",
        invalidFilename: "파일명 시작 문자는 2, S, Q 중 하나여야 합니다",
        invalidFileType: ".xlsx 형식의 파일만 업로드할 수 있습니다"
    },
    publicLang: {
        DeleteSuccess: "삭제 성공",
        HelpMessage: "돕다",
        PreviousPage: "이전 페이지",
        NextPage: "다음 페이지",
        Page: "페이지",
        CourierNumberIsNotNull: "택배 번호는 비워 둘 수 없습니다",
        CourierNumber: "택배 번호",
        InputRequiredValue: "필수 항목을 먼저 입력하십시오!",
        containerIdNotExists: "컨테이너 ID가 존재하지 않거나 이미 수령되었습니다",
        CartonIdNumNotExists: "카세트 ID 가 존재하지 않거나 찾았습니다",
        PleaseOneLeast: "최소한 하나를 선택해주세요.",
        AreUpadte: "선택한 레코드를 업데이트 하시겠습니까?",
        NotAllowtodeleteCancel: "삭제/취소할 수 없습니다",
        Notprintfirst: "분배하기 전에 인쇄할 수 없습니다. 먼저 할당하십시오.",
        Notprintpackfirst: "박스를 스캔하기 전에 인쇄할 수 없습니다. 먼저 포장하십시오.",
        ProjectandWarehouse: "프로젝트 및 창고",
        AlertMessage: "알림 메시지",
        NewTemplateName: "새 템플릿 이름",
        ProjectTemplate: "프로젝트 템플릿",
        StyleSetting: "스타일 설정",
        NavigationMode: "네비게이션 모드",
        LeftLayout: "왼쪽 레이아웃",
        TopLayout: "상단 레이아웃",
        Arecancel: "삭제하시겠습니까?",
        Areconfirm: "제출하시겠습니까?",
        Yes: "예",
        No: "아니오",
        SKUSearch: "SKU 검색",
        StatusNotNew: "주문 상태는 새로운 상태일 수 없습니다",
        PubOk: "확인",
        theIstAdministrator: "현재 사용자에게 권한이 할당되지 않았습니다. 관리자에게 문의하십시오.",
        PleaseSltAtleast: "최소한 하나를 선택해주세요.",
        ColumnSearchRequired: "데이터를 불러오기 전에 조회 조건을 하나 이상 설정해 주세요.",
        PleaseCheckDisplayableFirst: "먼저 displayable를 확인하십시오!",
        pleaseOneOnly: "하나만 선택해주세요.",
        SelectRestrict: "선택한 데이터 개수는 100 줄 이상이어야 합니다",
        PleaseFirst: "먼저 선택해주세요.",
        DraglistSort: "정렬을 위해 목록을 드래그하십시오",
        CreatTime: "생성 시간",
        Clear: "지우기",
        Save: "박스 저장",
        UpdateSuccess: "업데이트 성공",
        PasswordUpdatedSuccessfully: "비밀번호가 성공적으로 업데이트되었습니다!",
        Project: "프로젝트",
        PleaseSelect: "선택해주세요",
        Required: "필수",
        ThenotEmail: "유효하지 않은 이메일 주소입니다",
        PleaseEnter: "입력해주세요",
        PleaseMobileNumberCorrectly: "올바른 전화 번호를 입력해주세요",
        RequireNumerFormat: "숫자 형식을 입력해주세요",
        SystemAdministrator: "시스템 구성 오류, 관리자에게 문의하십시오",
        Download: "다운로드",
        Preview: "미리보기",
        Wrongconfiguration: "잘못된 구성",
        NotAllowToOverReceive: "초과 수령을 허용하지 않습니다",
        Search: "검색",
        Close: "박스 닫기",
        sendEdi: "EDI 보내기",
        rePrint: "사전 인쇄",
        Cancel: "취소",
        Confirm: "확인",
        CheckComplete: "포장완료 확인",
        CancelCheckComplete: "포장완료 확인 취소",
        Template: "템플릿",
        Loading: "로딩",
        notExistScanInList: "{0} 입고 스캔 목록에 존재하지 않습니다",
        prompt: "알림",
        closePrompt: "주문을 닫으시겠습니까?",
        cancelPrompt: "주문 취소를 확인하시겠습니까? 이 작업은 되돌릴 수 없습니다.",
        IncorrectConfiguration: "잘못된 구성",
        NoreportFound: "보고서를 찾을 수 없습니다",
        PleaseinputEmail: "이메일을 입력해주세요!",
        Upload: "업로드",
        UploadPhoto: "사진 업로드",
        UploadSuccess: "업로드 성공!",
        DownloadCenter: "다운로드 센터",
        FileName: "파일 이름",
        Action: "액션",
        overScanMsg: "{0} 초과 수령 불가",
        overRemoveMsg: "{0} 초과 삭제 불가",
        locationIsNull: "위치를 입력해주세요",
        ConfirmShipment: "발송 확인?",
        LastSKUCheckCompletePrompt: "주문 포장이 완료되었습니다. 확인하세요.",
        statusError: "{0} 상태 오류",
        waveIdIsNotEmpty: "{0} 주문에 이미 웨이브 ID가 있습니다",
        UploadFileOverSize: "업로드한 파일이 크기 제한을 초과했습니다. 확인해주세요",
        UploadFailed: "업로드 실패",
        DownloadFailed: "다운로드 실패",
        cardNeedReplace:"카드를 교체해야 합니다",
        NoPickedStockInContainer:"이 컨테이너 안에 물건을 고르지 않았어!",
        needToHangGooseDownGoldMedal:"구스다운 금메달 을 걸어야 한다",
        requestApproval:"승인 신청",
        cancelRequest:"취소 요청",
        MustBeGreaterThanZero: "{0} 은(는) 0보다 커야 합니다"
    },
    roleGe: {
        RoleLevel: "역할 수준",
        ModuleName: "모듈 이름",
        SubModuleName: "하위 모듈 이름",
        Add: "추가",
        Delete: "삭제",
        Edit: "편집",
        EditRole: "역할 편집",
        CreateRole: "역할 생성",
        RoleName: "역할 이름",
        RoleType: "역할 유형",
        PleaseSelect: "선택해주세요",
        Description: "설명",
        Save: "박스 저장",
        pleaseOneOnly: "하나만 선택해주세요",
        SaveSuccessfully: "성공적으로 저장됨",
        RuleType: "규칙 유형",
        RuleName: "규칙 이름",
        Organization: "조직",
        Project: "프로젝트",
        Search: "검색",
        Creator: "생성자",
        CreateTime: "생성 시간",
        Modifier: "수정자",
        ModifiyTime: "수정 시간",
        Next: "다음",
        SortSubmit: "순서 제출",
        Inventory: "재고",
        TableName: "테이블 이름",
        FieldName: "필드 이름",
        InventoryFieldName: "재고 필드 이름",
        FieldType: "필드 유형",
        Condition: "조건",
        CustomizeValue: "사용자 정의 값",
        OrderBy: "정렬 기준",
        Operation: "작업",
        SO: "주문",
        Rule: "규칙",
        Grouping: "그룹화",
        GroupingAndOrderBy: "그룹화 및 정렬",
        ReportSetting: "보고서 설정",
        Import: "가져오기",
        Lookup: "조회",
        ReportName: "보고서 이름",
        ConfigEnableUser: "사용 가능한 사용자 구성"
    },
    menu: {
        NotificationList: "알림 목록",
        Read: "읽음",
        Unread: "읽지 않음",
        ViewMore: "더 보기",
        YouhaveViewedNotifications: "모든 알림 목록을 확인했습니다.",
        Receiver: "수신자",
        ReadTime: "읽은 시간",
        Status: "상태",
        Subject: "제목",
        RefType: "참조 유형",
        RefNum: "참조 번호",
        StartTime: "시작 시간",
        CompleteTime: "완료 시간",
        FirstName: "이름",
        LastName: "성",
        DisplayName: "표시 이름",
        MiddleName: "중간 이름",
        Email: "이메일",
        Title: "직위",
        Gender: "성별",
        Male: "남성",
        Female: "여성",
        Department: "부서",
        Position: "직책",
        Telephone: "전화번호",
        City: "도시",
        TimeZone: "시간대",
        DefaultLanguage: "기본 언어",
        PerformanceFeedback: "성과 피드백",
        SimulateUser: "사용자 시뮬레이션",
        ReleaseUser: "해제 사용자",
        PrintNode: "인쇄 노드",
        Logout: "로그아웃",
        NoRecordfound: "기록을 찾을 수 없음"
    },
    easyCron: {
        Specify: "설명",
        NoSet: "설정 없음",
        OnlyDaysWeeksSet: "하루와 일주일 중 하나만 설정할 수 있습니다",
        Perday: "매일",
        Between: "사이",
        Day: "일",
        to: "부터",
        PreHour: "매 시간마다",
        Hour: "시간",
        From: "부터",
        PerMinute: "매 분마다",
        Minute: "분",
        PerYear: "매년",
        Year: "년",
        Start: "시작",
        Expire: "만료",
        dayWeekNoset: "일 또는 주를 정의해주세요",
    },
    pubGicSet: {
        EachGroupRow: "각 주문의 행 수",
        SplitRec: "배송서 분리",
        SelectSKU: "SKU 선택",
        SelectOneSKU:"SKU를 선택해 주세요",
        QuantityTypeError: "개수 형식 오류",
        soQty: "주문 수량",
        OrderType: "주문 유형",
        SelectFieldName: "필드 이름 선택",
        SkuDesc: "상품 설명",
        WarehouseCode: "창고 코드",
        NoRecordfound: "기록을 찾을 수 없음!",
        DragTheListTosort: "목록을 정렬하려면 드래그하세요",
        AdvanceSearch: "고급 검색",
        AdvanceSort: "고급 정렬",
        FreezeCol: "열 고정",
        Clear: "지우기",
        Sort: "정렬",
        Search: "검색",
        FieldName: "필드 이름",
        OrderBy: "기준으로 정렬",
        Name: "이름",
        PleaseName: "이름을 입력해주세요",
        SearchTemplate: "필터 템플릿",
        AdvanceSearcheTemplate: "고급 검색 템플릿",
        AreyoudeleTask: "선택한 레코드를 삭제하시겠습니까?",
        UserResetChanges: "다음 작업은 사용자가 수정한 권한을 지우게 됩니다. 계속 진행하시겠습니까?",
        ResetPasswordsConfirm: "비밀번호가 NULL로 재설정됩니다. 계속하시겠습니까?",
        ResetPasswordsButton: "비밀번호 재설정",
        InvalidSKU: "SKU {0} 유효하지 않음.",
        NotEnoughQtyPack: "{0} 너무 많이 상자에 넣는 것을 허락하지 않는다",
        NotEnoughQtyCancelPack: "{0} 용량을 초과하여 컨테이너를 취소하는 것을 허용하지 않는다",
        CartonClose: "{0} 박스가 이미 닫혔습니다.",
        UnpackedErrorWithEmptyCarton: "{0} 빈 상자는 더 이상 해제할 수 없습니다.",
        NotAllowOverPack: "{0}은(는) 과다 포장이 허용되지 않습니다.",
        ScanPackDecodeError: "바코드 스캔 형식 오류.",
        NotEnoughSkuRemoved: "상자에 충분한 {0} 수량이 없습니다.",
        unscanpackDataNotCancel: "검색되지 않은 패키지의 데이터를 취소할 수 없습니다",
        cartonQtyTooLarge: "상자의 수량이 너무 많다",
        Yes: "예",
        No: "아니요",
        delete: "삭제",
        PleaseTamplateNameFirst: "먼저 템플릿 이름을 선택해주세요",
        SaveSuccess: "저장 성공",
        Mandatory: "필수",
        Pleaseselect: "선택해주세요",
        SelectPicture: "사진을 선택해주세요",
        Split: "분할",
        FromValue: "시작 값",
        ToValue: "종료 값",
        NotAllowToSplit: "분할할 수 없음",
        PleaseSelectFieldName: "필드 이름을 선택해주세요",
        FieldAddedRepeatedly: "필드 이름은 중복으로 추가할 수 없습니다",
        ToLocationRequired: "대상 위치는 필수입니다",
        QtyRequired: "수량은 필수입니다",
        qtyTolocatioRequired: "대상 위치 수량은 필수입니다",
        PleaseCheckTheData: "데이터를 확인해주세요",
        ToValueCannotBeEmpty: "종료 값은 비워둘 수 없습니다",
        RecQty: "수령 수량",
        Location: "위치",
        ToLocation: "대상 위치",
        LocationISrequired: "위치는 필수입니다",
        NewContainer: "새 컨테이너",
        LoadedCartonQty: "로드된 상자 수량",
        ContainerNo: "컨테이너 번호",
        SSCC: "상자 번호/송장 번호",
        trackingNo: "추적 번호",
        SSCC1: "상자번호",
        AmrContainerNo: "컨테이너 번호",
        iWmsContainerNo: "컨테이너 번호",
        HiddenTable: "폼 숨기기",
        logisticsid: "송장 번호",
        RemoveCartonFromContainer: "컨테이너에서 상자 제거",
        RelID: "시스템 출고번호",
        PackID: "포장 ID",
        Carton: "박스번호",
        SKUQty: "상품 수량",
        NewPallet: "새 팔레트",
        PalletNo: "팔레트 번호",
        WeightPallet: "팔레트 무게",
        Length: "길이",
        InputaNumber: "숫자를 입력해주세요",
        Width: "너비",
        Height: "높이",
        CBM: "CBM",
        Weight: "무게",
        WeightUOM: "무게 단위",
        LoadedPalletQty: "로드된 팔레트 수량",
        RemovePalletfromContainer: "컨테이너에서 팔레트 제거",
        Remarks: "비고",
        Desc: "세부",
        SKU: "제품번호",
        LogicalWH: "논리 창고",
        LotID: "로트 ID",
        AvailableQty: "사용 가능 수량",
        AdjustQty: "조정 수량",
        ReasonCode: "조정 이유",
        Action: "추가 또는 감소",
        Adjust: "조정",
        NotEnoughInventoryToAdjust:"재고 조정이 부족했습니다",
        ActionCannotBeEmpty: "더하기나 빼기가 비어 있는 것은 허용되지 않는다",
        ToLocationCannotBeEmpty: "대상 저장소가 비어 있는 것을 허용하지 않습니다",
        ToSkuCannotBeEmpty: "대상 저장소가 비어 있는 것을 허용하지 않습니다",
        NotEnoughInventoryToMove : "적절한 재고 이동이 없습니다",
        DataNotChange: "데이터가 변경되지 않았으므로 저장할 필요가 없습니다",
        DataModifyNotSave: "수정된 데이터가 저장되지 않았습니다",
        BatchUpdateShipment: "일괄 업데이트 발송",
        BathUpdate: "일괄 업데이트",
        BatchUpdate: "일괄 업데이트",
        ButtonConfig: "버튼 구성",
        ButtonConfigName: "버튼 구성 이름",
        BePrint: "BePrint",
        ActionValue: "동작 값",
        DeAllocation: "할당 해제",
        BatchNo: "생산 일련 번호",
        Qty: "수량",
        originalLotId: "원본 로트 ID",
        soLineSeq: "주문 라인 순서",
        PickLineSeq: "픽 라인 순서",
        ModifyTime: "수정 시간",
        ShipOutDate: "출고 날짜",
        GenerateLocation: "위치 생성",
        RowName: "행 이름",
        ColumnInRow: "행의 열",
        LevelInRow: "행의 레벨",
        BinsinLocation: "위치의 바구니",
        CartonToContainer: "상자에서 컨테이너로",
        CartonToPallet: "상자에서 팔레트로",
        PalletToContainer: "팔레트에서 컨테이너로",
        Error: "오류",
        Lookup: "조회",
        PrePrintLPN: "사전 인쇄 LPN",
        NumberOfLPNLabelRequired: "LPN 라벨 번호 필수",
        Print: "출력",
        ReprintLPN: "재인쇄 LPN",
        Lpn: "LPN",
        Reprint: "재인쇄",
        LastPrinted: "마지막으로 인쇄된",
        MoveLogic: "이동 로직",
        Reason: "이유",
        FromLocation: "출발 위치",
        MoveQty: "이동 수량",
        ColumnName: "필드 이름",
        printReportColumn: "보고서 열 이름 인쇄",
        ScanIn: "입고 스캔",
        RecID: "주문 번호",
        CartonID: "상자 ID",
        TraceID:"추적 ID",
        ContainerId: "컨테이너 ID",
        CartonIdNum: "상자 번호",
        DeleteCartonID:"상자 번호 지우기",
        CartonIdQty:"상자 번호 수량",
        CartonIdNumRegExp:"상자 번호 정규 표현식이 잘못되었습니다",
        CartonIdNumFormatError:"오류 상자 번호 # {0}, 다시 검색하십시오",
        ContainerIdIsEmpty: "컨테이너 ID는 필수입니다",
        EPC: "반품 코드",
        EPCIsEmpty: "반품 코드는 필수입니다",
        EPCFormatError:"위조 방지 코드 이상, 다시 인식해 주세요",
        EpcQtyMustBeOne:"반품 코드는 한 번에 하나씩만 스캔할 수 있습니다",
        cartonTypeIsEmpty: "상자 유형은 필수입니다",
        ConvertToReceive: "수신으로 변환",
        CancelGR: "GR 취소",
        NewGR: "새 GR",
        Descr: "제품설명",
        ASNQty: "예정 수량",
        OutstandingQty: "미포장수량",
        ContainerIdQty: "컨테이너 ID 수량",
        ScanAction: "스캔 이벤트",
        RemoveSku: "삭제",
        addSku: "추가",
        StockStatus: "재고 상태",
        LockScanQty: "스캔수량 고정",
        LockContainer: "상자 제거",
        NoofSKU: "상자 내 포장된 제품 종류",
        NoofCartonID: "상자 ID 수",
        UOM: "수량 단위",
        ScanPack: "스캔 포장",
        WaveID: "웨이브 번호",
        CancelPack: "포장 취소",
        PrintPackingList: "피킹 리스트 인쇄",
        PackingList: "포장 목록 인쇄",
        AllocatedQty: "할당수량",
        PackedQty: "전체 포장된 수량",
        PackedQty2: "상자 내 포장된 수량",
        RemoveScanItem: "차감스캔",
        IsCarton: "상자 ID 로 스캔",
        ScanInDirectly:"직접 스캔",
        IsPrePack: "사전 포장 여부",
        IsTraceId: "추적 ID로 스캔",
        UnpackQty: "전체 미포장 수량",
        Detail: "세부",
        Percentage: "백분율",
        NoofCarton: "상자 수",
        Createdby: "생성자",
        CloseAndNew: "닫고 새로 만들기",
        New: "신규",
        Remove: "박스 제거",
        Append: "박스 추가",
        ImportScanningFile: "스캔 파일 가져오기",
        ImportSacnningFileGroupName: "스캔 파일 가져오기",
        PrintSSCC: "SSCC 인쇄",
        PrintCarton: "상자 인쇄",
        CartonNoSSCC: "박스번호",
        ScannedQty: "스캔된 수량",
        CartonNo: "상자 번호",
        CartonType: "상자 유형",
        DimUOM: "길이 단위",
        GrossWeight: "총 중량",
        NetWeight: "순 중량",
        PleaseNewOneCartonFirst: "먼저 새로운 상자를 생성해주세요",
        Nosscc: "상자 번호",
        CancelTransit: "트랜짓 취소",
        Transit: "트랜짓",
        Step: "단계",
        FromQty: "출발 수량",
        ToQty: "목표 수량",
        ToSku: "목표 상품",
        FromSku: "출발 상품",
        CourierEdi: "택배 EDI",
        IntersoftGenerateLabel: "Intersoft 라벨 생성",
        IntersoftCancelLabel: "Intersoft 라벨 취소",
        IntersoftGenerateMainfest: "Intersoft 메인페스트 생성",
        exportPackageData: "포장 데이터 내보내기",
        orderCheckCompleteStartTime: "주문 확인 완료 시작 시간",
        orderCheckCompleteEndTime: "주문 확인 완료 종료 시간",
        whetherToPrintOnlyCompletedOrders: "완료된 주문만 인쇄할지 여부",
        addSoToWave: "주문을 웨이브에 추가",
        waveId: "웨이브 ID",
        ref01: "참조 코드 01",
        ref02: "참조 코드 02",
        ref03: "참조 코드 03",
        ref04: "참조 코드 04",
        ref05: "참조 코드 05",
        query: "쿼리",
        reset: "재설정",
        save: "박스 저장",
        gift:"경품",
        notGiftScanAntiCode:"사은품이 아닌 이상 위조 방지 코드를 스캔해야 한다.",
        searchCartonByWave:"상자를 파동으로 검색합니다",
        importSscc:"상자 번호 가져오기",
        pleaseScanAntiCode:"반품 코드를 스캔해 주세요.",
    },
    manual: {
        Manual: "수동",
        New: "새로 만들기",
        AddToPick: "피킹에 추가",
        Unpick: "피킹 취소",
        SO: "주문 번호",
        Sku: "상품",
        RecID: "주문 번호",
        BatchNo: "배치 번호",
        SODate: "주문 날짜",
        AllQty: "할당 수량/주문 수량",
        AllocateLocation: "할당 위치",
        Status: "상태",
        LotID: "로트 ID",
        RecDate: "수령 날짜",
        RecQty: "수령 수량",
        AvailableQty: "사용 가능 수량",
        AllocateQty: "할당 수량",
        ShippedQty: "배송된 수량",
        MANUFACTUREDate: "제조 날짜",
        EXPIRYDate: "유통 기한",
        SHELFDate: "진열 날짜",
        NewpickPleasego: "새로운 피킹을 만들고 계속하세요"
    },
    login: {
        SignAccount: "기존 계정으로 로그인",
        loginTitle1: "다시 오신 것을 환영합니다",
        loginTitle2: "계정에 로그인해주세요",
        loginTitle3: "2단계 검증",
        loginTitle4: "이 추가 절차는 현재 로그인한 계정이 확실히 당신 본인임을 증명할 수 있습니다",
        loginTitle5:"아래 전화번호로 인증번호 받기：**** **",
        loginTitle6:"",
        loginTitle7:"지불 필요",
        loginTitle8:"일반 통신 요금",
        loginTitle9:"이메일로 인증번호 받기",
        loginTitle10:"인증 코드",
        loginTitle11:"보안 코드 입력",
        loginTitle12:"이 브라우저를 신뢰하시겠습니까?",
        loginTitle13:"웹 사이트에 로그인하려면 여전히 암호가 필요하지만 다음 로그인 시에는 인증 코드를 입력하도록 요청하지 않습니다.(향후 ",
        loginTitle27:"일)",
        loginTitle14:"Google 또는 Microsoft Authenticator와",
        loginTitle15:"같은 응용 프로그램을 통해 인증 코드 얻기",
        loginTitle16:"설치",
        loginTitle17:"설정 취소",
        loginTitle18:"선택한 TOTP 설치",
        loginTitle19:"(시간 기반 일회용 비밀번호) 인증기",
        loginTitle20:"QR코드 스캔",
        loginTitle21:"또는",
        loginTitle22:"'비밀'을 입력하십시오.",
        loginTitle23:"인증기 응용 프로그램",
        loginTitle24:"설정 완료",
        loginTitle25:"비밀",
        loginTitle26:"비밀 오류",
        Verify: "검증",
        PleaseUsername: "사용자 이름을 입력해주세요!",
        Username: "사용자 이름",
        Password: "암호",
        language: "언어",
        PleasePassword: "암호를 입력해주세요!",
        ForgotPassword: "암호를 잊으셨나요",
        KeepIn: "로그인 상태 유지",
        SignIn: "로그인",
        Or: "또는",
        RegisterNewAccount: "새 계정 등록",
        NeedHelpContactAdmin: "도움이 필요하세요? 시스템 관리자에게 문의하세요",
        DonHaveAccount: "계정이 없으신가요?",
        SignUPnow: "가입",
        UserPasswordError: "사용자 이름 또는 암호가 잘못되었습니다",
        Cancel: "취소",
        Create: "생성",
        EmailAddress: "이메일 주소",
        VerificationCode: "인증 코드",
        Pleaseverification: "인증 코드를 입력해주세요",
        Sendverification: "인증 코드 전송",
        NewPassword: "새 암호",
        passWordError1: "암호 길이는 8~64자여야 합니다.",
        passWordError2: "",
        passWordError3: "- 소문자 1자",
        passWordError4: "- 대문자 1자",
        passWordError5: "- 숫자 1자",
        passWordError6: "- 특수문자 1자",
        ConfirmNewPassword: "새 암호 확인",
        PleaseConfirmPassword: "암호를 확인해주세요",
        TwopasswordsInconsistent: "두 번 입력한 암호가 일치하지 않습니다!",
        RegistrationSuccess: "등록 성공",
        VerificationAddress: "인증 코드를 전송하려면 클릭해주세요",
        Submit: "제출",
        NoUserExists: "사용자가 존재하지 않습니다",
        CaptchaError: "인증 코드가 유효하지 않습니다",
        CaptchaVerified: "인증 성공",
        emailError:"잘못된 이메일 주소입니다.",
        authenticationFailure:"인증 실패",
        SsoAccountMismatch:"Microsoft 계정이 입력한 계정과 일치하지 않습니다. 다시 시도하세요.",
        OldPassword: "이전 암호",
        NewpasswordNotoldPassword: "새 암호는 이전 암호와 동일할 수 없습니다",
        OriginalPasswordError: "이전 암호가 잘못되었습니다!",
        ResetPassword: "암호 재설정",
        firstLoginChangePassword: "처음 로그인, 암호를 변경하십시오",
        registerForm: "등록 양식",
        UserAlreadyExist: "사용자가 이미 존재합니다!",
        ResetAliasName: "별명 재설정",
        ChangeAliasName: "별명 변경",
        dashboardPortal:"대시보드 포털",
        signOut:"로그아웃",
        view:"보기",
        previous:"이전",
        noReportIsSetupForThisAccount:"이 계정에 대한 보고서가 설정되지 않았습니다.",
        PasswordExpiryWarning: "비밀번호 만료 경고",
        PasswordExpiryMessage: "비밀번호가 곧 만료됩니다",
        PasswordExpiredToday: "비밀번호가 오늘 만료됩니다",
        PasswordExpiryDaysLeft: "비밀번호가 {days} 일 후 만료됩니다",
        PleaseChangePasswordImmediately: "즉시 비밀번호를 변경해 주세요"
    },
    batchReceive: {
        BatchReceive: "일괄 수령",
        Query: "조회",
        Accept: "수락",
        All: "모두",
        Received: "수령됨",
        NotReceive: "미수령",
        ReceiveLocation: "수령 위치",
        EnterWordsQuery: "4글자 이상 입력하여 조회",
        EXPQty: "예상 수량",
        RCVQty: "수령 수량",
        RCVQtyEA: "수령 수량 EA",
        TOID: "TOID",
        RCVLOC: "수령 위치",
        EXPIRYDATE: "유효 기간",
        Descr: "제품설명",
        SKU: "제품번호",
        UDF1: "사용자 정의 1",
        UDF2: "사용자 정의 2",
        UDF3: "사용자 정의 3",
        ReceiveRequired: "수령 위치는 필수입니다",
        RCVQtyCheck: "수령 수량은 0보다 커야 합니다",
        RCVQtyGtExpQty: "수령 수량은 예상 수량보다 클 수 없습니다",
        Status: "상태",
        Line: "라인",
        RecDate: "수령 날짜",
        LocationCode: "위치 코드",
        RecQty: "수령 수량",
        RecBaseQty: "수령 수량",
        DamageQty: "손상 수량",
        DamageBaseQty: "손상 수량",
        HoldQty: "보류 수량",
        HoldBaseQty: "보류 수량",
        Remarks: "비고",
        Desc:"상세",
        ProductType: "제품 유형",
        ASNQty: "ASN 수량",
        ASNBaseQty: "ASN 수량",
        UOM: "단위",
        PackageQty: "패키지 수량",
        ManufactureDate: "제조 날짜",
        ExpiryDate: "유통 기한",
        ShelfDate: "진열 날짜",
        PalletID: "팔레트 ID",
        CartonID: "상자 ID",
        TraceID:"추적 ID",
        Article: "제품",
        NotAllowToOverReceive: "초과 수령이 허용되지 않습니다"
    },


    reportSetting: {
        DevName: "Dev 이름",
        ReSQL: "SQL 다시 생성",
        ColumnDetail: "열 세부 정보",
        ReportType: "보고서 유형",
        ReportVersion: "보고서 버전",
        EnglishName: "영어 이름",
        SimplifiedCNName: "중국어 간체 이름",
        TraditionalCNName: "중국어 번체 이름",
        EnglishTipsName: "영어 팁 이름",
        SimplifiedCNTipsName: "중국어 간체 팁 이름",
        TraditionalCNTipsName: "중국어 번체 팁 이름",
        DisplaySeq: "표시 순서",
        CalculateType: "계산 유형",
        CustCode: "고객 코드",
        CustName: "고객 이름",
        ProjectCode: "프로젝트 코드",
        ProjectName: "프로젝트 이름",
        Beautify: "꾸미기",
        Verify: "확인",
        Generate: "생성",
        Version: "버전",
        Assign: "할당",
        AssignName: "담당자",
        CopyFromMaster: "마스터에서 복사",
        plInpuSku: "SKU를 입력하세요",
        BatchSave: "일괄 저장",
        SelectAllforSearchable: "검색을 위해 모두 선택",
        SelectAllforDisaplyable: "표시를 위해 모두 선택",
        importTemplate: "템플릿 가져오기",
        Upload: "업로드",
        Clone: "복제",
        importConfig: "구성 가져오기",
        importColumn: "열 제목",
        Mapping: "매핑",
        Uniquekey: "고유키 여부",
        DefaultType: "기본 유형",
        DataType: "데이터 유형",
        Datalength: "데이터 길이",
        DecimalalPlace: "소수점 자릿수",
        DateTimeFormat: "날짜 및 시간 형식",
        StartPosition: "시작 위치",
        EndPosition: "끝 위치",
        Delimiter:"구분자",
        DelimiterDesc:"기본값은'/'이며,'null'은 구분자가 없고,'blank'은 공백이다",
        ReferenceKey: "참조 키",
        RangeValue: "범위 값",
        DefaultValue: "기본 값",
        Mandatory: "필수 여부",
        CombineFields: "필드 병합",
        UploadConfig: "구성 업로드",
        FileType: "파일 유형",
        Delimilter: "구분자",
        CloneTemplate: "템플릿 복제",
        TableColumn: "테이블 필드",
        OperationRule: "작업 규칙",
        withHeader: "헤더 포함",
        excelStartRow: "엑셀 시작 행",
        isPrintReport:"보고서 인쇄",
        printReportCode:"보고서 코드 인쇄",
    },

    soPage:{
        PackedFirst:"인쇄가허용되지않습니다. 먼저포장하십시오.",
        inputAllQty:"할당수량을입력하십시오!",
        labelCreateDhlShipmentId: "새로만들기 DHL Shipment ID",
        labelAddOrderToShipmentId: "주문추가 Shipment ID",
        labelShipmentReference: "Shipment Reference",
        labelConfirm: "확인",
        labelQuery:"질의",
        msgShipmentReferenceIsNull: "Shipment Reference 비워둘수없음",
    },
  asnPage:{
    mustPutaway:"상태는 Putaway여야 합니다!",
    filesMaxSize:"업로드 파일 총 크기는 500M를 초과할 수 없습니다!",
    UploadPhoto: "사진 업로드",
    saveData:"데이터가 변경되지 않았습니다!",
    saveHeaderPlease:"먼저 헤더 데이터를 저장하십시오!",
    pleaseSelectTargetProject: "대상 프로젝트를 선택하십시오.",
    targetProjectNotExist: "대상 프로젝트가 존재하지 않습니다!",
    changeWhProjectTitle: "WH/프로젝트 변경",
    changeWhProjectLabel: "WH/프로젝트",
  },
    job: {
        Name: "작업 이름",
        Class: "작업에 대응하는 클래스",
        Remark: "비고",
        Type: "작업 유형",
        ParamName: "매개변수 이름",
        ParamValue: "매개변수 값",
        Seq: "일련번호",
        Add: "추가",
        Save: "박스 저장",
        Run: "실행",
        Delete: "삭제",
        Reset: "초기화",
        Query: "조회",
        Total: "총",
        Records: "레코드",
        notNull: "비워 둘 수 없습니다!",
        Activate: "활성화",
        Inactivate: "비활성화",
        Action: "액션",
        Status: "상태",
        Expression: "식",
        BusinessType: "비즈니스 시스템 유형",
        StartTime: "시작 시간",
        ActionNo: "액션 번호",
        CreateExpression: "식 생성",
        DateTime: "날짜 형식",
        Year: "년",
        Month: "월",
        Day: "일",
        Hour: "시",
        Minute: "분",
        Second: "초",
        StatusCanNotDel: "활성 상태는 삭제할 수 없습니다!",
        ExpressionNotCorrect: "식이 올바르지 않습니다!",
        TriggerStatus: "트리거 상태",
        PrevFireTime: "이전 실행 시간",
        NextFireTime: "다음 실행 시간"
    },
    wine: {
        AvailableQty: "輸入數量超出有效庫存數量!",
        inputEnglish:"只能输入英文",
        inputChinese:"只能输入中文",
        maxCharacters:"最大.{0}位",
        mustInputChinese:"如果没有填写英文地址,则中文地址必填.",
    },
    printLabel:{
        NumberOfQrCodeLabelRequired: "Number of QR Code Label Required",
        NumberOfRelIdLabelRequired: "Number of Rel Id Label Required",
        labelType:"Label Type",
        qrCodeLabel:"Pre-Print Label",
    },
    cfs:{
        OrderCancel:"订单拦截",
        operationSuccess:"操作成功",
        orderNo:"订单编号",
        loadingNo:"装箱单号",
        platformOrderNo:"Platform Order No",
        parcelNo:"条码",
        unScanQty:"未扫描数量",
        invoiceFlag:"Print Label / Invoice Flag",
        scannedQty:"已扫描数量",
        parcelNoTrackingNo:"Parcel No. / Tracking No.(Last Mile Label)",
        trackingNo:"Tracking No.(Last Mile Label)",
        destinationCountry:"Destination Country",
        courier:"Courier",
        parcelNotOrder:"Parcel not belong to this order",
        printLabel:"Print Label",
        printDhlInvoice:"Print DHL Commercial Invoice",
        scanLoad:"扫描装箱",
        awbMbl:"AWB / MBL / Tracking No",
        uldNo:"Container No. / ULD No.",
        collectionTimeFrom:"Collection Time From",
        collectionTimeTo:"Collection Time To",
        createLoading:"创建装箱单",
        confirmLoading:"装箱确认",
        ediSendFlag:"EDI Send Flag",
        resetFirst:"Please reset.",
        noOfDestinationLabelRequired:"No. of Destination Label required",
        orderNumber:"运单号",
        barcode:"条码",
        damage:"损坏",
        dimensions:"尺寸",
        nextOrder:"下一个订单",
        delete:"删除",
        printViewPdf: "打印箱贴",
    },
    support:{
        org:"Org",
        project:"Project Name",
        a01ReopenASNAsn:"ASN#",
        note:"Note",
        submit:"Submit",
        reset:"Reset",
        c01MovePOToWarehousePO:"PO#",
    },
    printerConfig: {
        refresh:"刷新打印机列表",
        servicesName:"服务器名称",
        ip:"IP地址",
        printerName:"打印机名称",
    },
    scanPack: {
        orderNoRequired: '주문 번호는 비워 둘 수 없습니다',
        cancelCheckCompleteMsg: '모든 포장 상자를 삭제하시겠습니까?',
        cancelCheckCompleteMoveMsg: '자동으로 모든 재고를 원래의 위치로 돌려 놓으시겠습니까?',
        cancelPickForCheckCompleteMsg: '아래 SKU가 피킹되었지만 포장되지 않았습니다. 피킹을 취소하시겠습니까?',
        cancelCheckCompleteNo: '아니요',
        cancelCheckCompleteYes: '예',
        title: '확인',
        currentScanQty: '현재 스캔 수량',
        deletePickingData:"픽업 데이터 삭제 확인하시겠습니까?",
        firstCancelCheckCompleteThenScanPack:"현재 주문의 부분 검토 완료, 검토 완료 취소 여부입니다",
        antiCounterfeitingCodePleaseConfirm:"출고되지 않는 위조 방지 코드입니다. 확인해주세요.",
        currentBrand:"현재 브랜드",
        getExpressNumber:"송장번호를 받다",
        ssccAlreadyUse:"SSCC#{0} 혼합 포장 주문을 허용하지 않습니다",
        scanByWave:"파수 id ({0})를 사용하여 스캔하십시오",
        notAllowedBatchClose: "현재 포장 데이터가 제출되지 않았습니다. 대량 포장 종료를 허용하지 않습니다"
    },
    skuSearch: {
        skuSearch: "상품 검색",
        upcSearch: "UPC 검색",
        sku: "상품 코드",
        multipleSku: "다중 상품 코드",
        skuFrom: "시작 상품 코드",
        skuTo: "끝 상품 코드",
        search: "검색",
        skuCode: "상품 코드",
        skuDesc: "상품 설명",
        upc: "바코드",
        style: "스타일",
        color: "색상",
        size: "사이즈"
    },
    invTrans: {
        transType: "거래 유형",
        transStatus: "거래 상태",
        orderNo: "단증 번호",
        transTimeFrom: "거래 시간 시작",
        transTimeTo: "거래 시간 끝",
        systemUser: "시스템 사용자",
        lotAttribute: "로트 속성",
        ownerCode: "소유자 코드",
        lotNo: "로트 번호",
        id: "추적 번호",
        back: "뒤로",
        transId: "거래 번호",
        transTime: "거래 시간",
        lineNo: "라인 번호",
        transactionTime: "거래 로그 시간 검색은 {0}일 이내의 검색이어야 합니다!",
        operator: "작업자",
        ownerCodeFrom: "소유자 코드 시작",
        ownerCodeTo: "소유자 코드 끝",
        skuFrom: "상품 시작",
        skuTo: "상품 끝",
        skuDescFrom: "상품명 시작",
        skuDescTo: "상품명 끝",
        lotNoFrom: "로트 번호 시작",
        lotNoTo: "로트 번호 끝",
        idFrom: "추적 번호 시작",
        idTo: "추적 번호 끝",
        locFrom: "위치 시작",
        locTo: "위치 끝",
        qtyFrom: "수량 시작",
        qtyTo: "수량 끝",
        unitQtyFrom: "단위 수량 시작",
        unitQtyTo: "단위 수량 끝",
        uomFrom: "단위 시작",
        uomTo: "단위 끝",
        descriptionFrom: "설명 시작",
        descriptionTo: "설명 끝",
        amount: "금액"
    },
    currency: {
        currency: "통화",
        description: "설명",
        currencySymbol: "통화 기호"
    },
    billingMaintance: {
        add: "추가",
        query: "조회",
        reset: "초기화",
        edit: "편집",
        billId: "청구서 번호",
        cutOffFrom: "마감일",
        billingPeriodFrom: "청구 시작일",
        billingPeriodTo: "청구 종료일",
        confirmDate: "확인 날짜",
        postDate: "게시 날짜",
        invoiceNo: "송장 번호",
        invoiceDate: "송장 날짜",
        billToName: "수취인",
        billToAddress1: "주소1",
        billToAddress2: "주소2",
        billToAddress3: "주소3",
        billToAddress4: "주소4",
        billToCity: "도시",
        billToProvince: "도",
        billToCountry: "국가",
        billToZip: "우편번호",
        billToContactName: "연락처",
        billToContactPhone: "전화번호",
        billToContactFax: "팩스",
        billToContactEmail: "이메일",
        currency: "통화",
        exchangeRate: "환율",
        lineNo: "라인 번호",
        chargeMethod: "요금 방법",
        tariffId: "세율",
        chargeCode: "요금",
        description: "설명",
        billDateFrom: "청구 시작일",
        billDateTo: "청구 종료일",
        billType: "청구 유형",
        billBase: "청구 기준",
        billUnit: "단위",
        overflowCharge: "초과 요금",
        accountCode: "계정",
        localExchangeRate: "지역 환율",
        baseAmount: "기본 금액",
        localAmount: "지역 금액",
        totalAmount: "총액",
        invoiceLineSeq: "송장 라인 번호",
        CreateMaintance: "생성",
        EditMaintance: "편집",
        PleaseinputBillId: "청구서 번호를 입력하세요",
        msgBillingPeriodFromLessThanTo: "청구 시작일이 청구 종료일보다 작습니다"
    },
    resPlan: {
        workingDayOnly: "근무일에만 적용",
        waveIdNotnull: "웨이브 번호는 비워둘 수 없습니다",
        needCreateResourcePlan: "리소스 플래닝을 생성해야 합니까?"
    },
    cycleCount: {
        Location: "위치 번호",
        createTicket: "티켓 생성",
        includeStatus: "상태 포함",
        reCount: "재계수",
        numberOfSplit: "분할 횟수",
        confirmToCreateTicketForLocation:"다음에는재고기록이밖의저장소를포함하고재고를시작하거나재조사를확인합니까?",
        confirmToReCountLocation:"재고품을 재차 조사합니까?"
    },
    handheldConfiguration: {
        handheldConfiguration: "핸드헬드 구성",
        handheldApplicationConfiguration: "핸드헬드 애플리케이션 구성",
        configName: "구성 이름",
        relatedFunction: "관련 기능",
        status: "상태",
        flowSetting: "플로우 설정",
        orderSearch: "주문 검색",
        scanning: "스캔",
        haveSearchScreen: "검색 화면이 있습니까?",
        scanName: "스캔 이름",
        promptMessage: "알림 메시지",
        actionSettings: "동작 설정",
        action: "동작",
        targetField: "대상 필드",
        field: "필드",
        stepSettings: "단계 설정",
        new: "신규",
        value: "값",
        type: "유형",
        length: "길이",
        dataLength: "데이터 길이",
        relatedSettings: "관련 설정",
        lockValue: "값 잠금?",
        displayIn: "표시 위치?",
        showCurrProgress: "현재 진행 상황 표시",
        showSummary: "요약 표시",
        info: "정보",
        showConfDialog: "구성 대화 상자 표시",
        displayText: "표시 텍스트",
        changeCommand: "명령 변경",
        last: "(최신)",
        completeOnCloseNext: "닫기/다음 완료?",
        suggestLocation: "권장 위치?",
        dialogSettings: "대화 상자 설정",
        input: "입력",
        mandatory: "필수",
        dimension: "차원",
        volume: "부피",
        grossWeight: "총 중량",
        netWeight: "순 중량",
        logicSettings: "로직 설정",
        use: "사용",
        priority: "우선순위",
        lastLocation: "최신 위치",
        nextEmptyLocation: "다음 빈 위치",
        pickLocation: "픽 위치",
        storageLocation: "저장 위치",
        closeToSameSku: "동일한 SKU에 가깝게",
        matchItemType: "동일한 유형과 일치",
        useProjectLocation: "프로젝트 위치 사용",
        useWarehouseLocation: "창고 위치 사용",
        scanSingle: "단일 라인 스캔?",
        displayInformation: "정보 표시",
        scanningScanNameCannotBeEmpty: "스캔 {0} 스캔 이름을 비워 둘 수 없습니다.",
        orderSearchScanNameCannotBeEmpty: "주문 검색 스캔 이름을 비워 둘 수 없습니다."
    },
    cycleCountMaster: {
        belowLocationAndSku: "다음 위치 및 SKU에 할당된 수량/보유 수량이 있습니다. 이를 무시하고 재고 조사 주문을 생성하시겠습니까?",
        belowSkuCreateCountOrder: "아래 SKU에 할당된 수량이 포함되어 있습니다. 이를 제외하고 재고 조사 주문을 생성하시겠습니까?",
        quantityNeedsToBeGreaterThan0: "수량은 0보다 커야 합니다",
        createCountOrderByNumber: "기본 카운트 횟수로 재고 조사 주문을 생성하시겠습니까?",
        countOrderCompleteOrder: "재고 조사 {0} 및 관련 티켓이 아직 처리 중입니다.\n" +
            "미결 거래를 종료하고 재고 조사를 완료하시겠습니까?"
    },
    confirmDeleteLoading: "주문이 이미 적재되었습니다. 적재 목록에서 제거하시겠습니까?",
    expDeliveryDateNotnull: "예상 배송일은 비워둘 수 없습니다!",
    scanIn: "입고 스캔",
    carrier: "운송업체",
    flightNo: "항공편 번호",
    parcelUnWeighed: "소포 미중량",
    airLine: "항공사",
    arrivedTime: "도착 시간",
    shipFrom: "출발지",
    shipTime: "출발 시간",
    services: "서비스",
    servicesProvider: "서비스 제공자",
    gatewayCannotBeEmpty: "게이트웨이를 비워둘 수 없습니다",
    serviceCannotBeEmpty: "서비스를 비워둘 수 없습니다",
    serviceProviderCannotBeEmpty: "서비스 제공자를 비워둘 수 없습니다",
    skynetPostal: "스카이넷 우편",
    battery: "배터리",
    batteryCannotBeEmpty: "배터리를 비워둘 수 없습니다",
    copyLoading: "적재 목록 복사",
    showAll: "모두 표시",
    processActionMsg: "이 작업을 확인하시겠습니까?",
    orderRef: "주문 번호",
    printNotConnected: "프린터 연결 실패",
    notLabelRecord: "레코드를 찾을 수 없습니다",
    collarBarcode: {
        woolenCollarBarcode: "털 칼라 바코드",
        woolenCollarBarcodeMismatch: "털 칼라 바코드 불일치",
        missing: "누락"
    },
    soStatus:{
        partialAllocated:"부분 할당",
        allocation:"할당",
        partialPicked:"부분적 선별",
        picked:"완전 선별",
        partialPacked: "부분 포장",
        packed: "전체 포장",
        partialLoaded: "부분 적재",
        loaded: "완전 장착",
        partialShipped: "부분 배송",
        shipped: "완전 배송",
        delivered:"배송",
        billed:"청구서",
        cancelled:"주문 취소",
        deleted:"삭제",
        closed: "주문 완료",
    },
    asnStatus:{
        partialReceived:"부분 수거",
        received:"완전 수령",
        partialPutaway: "부분 업로드",
        putaway: "완전히 업로드",
        cancelled:"취소 상태",
        deleted:"삭제 상태",
        closed: "닫힘 상태",
    },
    conditionCycleCount: {
        locationCode: "로케이션 코드",
        locationType: "로케이션 유형",
        locationName: "로케이션 명칭",
        zone: "존/구역",
        storageType: "보관 유형",
        noDataMsg: "선택된 데이터가 없으면 모든 레코드가 생성됩니다. 계속하시겠습니까?",
        SearchTitle: "Location Query, (Location 지정이 필요하지 않은 경우 [Create]를 클릭하십시오.)",
        create: "생성"
    },

    loading:{
        loadId:"ID 로드",
        container:"컨테이너 #",
        hidden: "숨기기",
        searchCartonByWave:"물결을 기준으로 용지함 검색",
        importSscc:"Sscc 가져오기",
        seal:"밀봉 #",
        containerType:"컨테이너 유형",
        vesselFight:"선박 전투",
        voyage:"항해 #",
        mbl:"MBL",
        hbl:"HBL",
        driver:"운전사",
        etd:"ETD",
        eta:"ETA",
        portOfLoading:"선적항",
        portOfDischarge:"하역항",
        portOfDestination:"목적항",
        loadFrom:"에서 로드",
        loadTo:"로드 대상",
        remarks:"코멘트",
        loadedCartonQty:"마운트 용지함 수",
        detailSearch:"세부내용 검색",
    },
    filterBy:"로 필터링",
    allocationResults: "할당 결과",
    importResults:"가져오기 결과",
    lastestNotifications:"가장 최근 {0} 알림",
    todayNotifications:"오늘 알림",
    yesterdayNotifications:"어제 알림",
    success:"성공",
    failed:"실패한",
    inputNumCharsThenPressEnter:"{0} 개의 문자를 입력한 후 Enter 키를 누르세요",
    queryCondition:"쿼리 조건",
    thaiName:"태국 이름",
    japaneseName:"일본 이름",
    headerJoinFieldName:"헤더 조인 이름",
    detailJoinFieldName:"디테일 조인 이름",
    queryFieldName:"쿼리 필드 이름",
    compareType:"비교 유형",
    fixedValue:"고정 값",
    todayDate:"오늘 날짜",
    pageType:"페이지 유형",
    codeMasterGroup:"코드 마스터 그룹",
    queryTable:"쿼리 필드 테이블",
    headerTable:"헤더 조인 테이블",
    detailTable:"디테일 조인 테이블",
    splitScan: {
        queryConditionCantBeNull: "조회 조건은 비울 수 없습니다",
        skuCannotBeEmpty: "SKU는 비워 둘 수 없습니다",
        noUnreviewedProductsExist:"미검토 상품이 존재하지 않습니다",
    },
    stdBalanceReport: {
        brand: "브랜드",
        size: "사이즈",
        volume: "단위체적 m³",
        totalVolume: "총체적 m³",
        minRecDate: "원래 입력 시간",
        department: "부서",
        sku: "상품",
        skuName: "품명",
        material: "자재 모델 번호/코드",
        specification: "규격",
        units: "단위",
        qty: "수량",
        inboundTime: "최근 입고 시간",
        outboundTime: "최근 출고 시간",
        period: "기간",
        remark: "비고/설명",
        Location: "창고 위치",
        prePicture: "이미지 미리보기"
    },

    // 로그인 모달 다국어
    sessionModal: {
        title: "로그인이 만료되었습니다",
        message: "장시간 비활성으로 인해 다시 로그인해 주세요",
        passwordChangedMessage: "비밀번호가 변경되었습니다. 다시 로그인해 주세요",
        username: "사용자명",
        password: "비밀번호",
        loginButton: "로그인",
        logoutButton: "로그아웃",
        usernameRequired: "사용자명과 비밀번호를 입력해 주세요",
        passwordRequired: "비밀번호를 입력해 주세요",
        loginFailed: "로그인 실패, 사용자명과 비밀번호를 확인해 주세요",
        loginError: "로그인 실패, 다시 시도해 주세요",
        loginSuccess: "재로그인 성공",
        loginLoading: "로그인 중...",
        loginTimeout: "요청 시간 초과, 다시 시도해 주세요",
        securityTitle: "보안 경고",
        securityMessage: "무단 데이터 수정이 감지되었습니다. 보안을 위해 다시 로그인해 주세요",
        securityWarning: "보안을 위해 신원을 확인해 주세요",
        tokenExpiredMessage: "세션이 만료되었습니다. 다시 로그인해 주세요",
        tokenInvalidMessage: "인증 토큰이 유효하지 않습니다. 다시 로그인해 주세요",
        noPermissionTitle: "권한 없음",
        noPermissionMessage: "이 리소스에 접근할 권한이 없습니다",
        okButton: "확인",
        projectChangedTitle: "프로젝트 변경됨",
        projectChangedMessage: "현재 프로젝트가 변경되었습니다. 올바른 프로젝트 데이터를 불러오려면 페이지를 새로 고침해 주세요.",
        reloadButton: "새로 고침",
        reloginButton: "다시 로그인"
    },
    pack: "포장",
    summary: "요약",
    searchByOrder: "주문별 검색",
    pieceScanMode: "단품 스캔 모드",
    materialsScanMode: "자재 스캔 모드",
    cartonScanMode: "카톤 스캔 모드",
    manualQtyEntry: "수량 수동 입력",
    scanRemoveMode: "스캔 제거 모드",
    pcsPerScan: "1회 스캔 수량",
    scan: "스캔",
    scanBarcodeHere: "바코드를 여기에 스캔하세요",
    scanCartonHere: "카톤을 여기에 스캔하세요",
    scanMaterialsHere: "자재를 여기에 스캔하세요",
    newCarton: "새 카톤",
    deleteCarton: "카톤 삭제",
    closeCarton: "카톤 닫기",
    showOutstandingData: "미완료 데이터 표시",
    removeQuantity: "수량 제거",
    piecesToRemove: "제거할 수량",
    enterQuantity: "수량 입력",
    piecesToAdd: "추가할 수량",
    open: "열림",
    closed: "닫힘",
    notFoundMaterial: "자재를 찾을 수 없습니다:",
    order: "주문",
    uploadScanningFile: "스캔 파일 업로드",
    printDoc: "문서 인쇄",
    packingInstructions: "포장 지침",
    vasInstructions: "VAS 지침",
    currentCarton: "현재 카톤",
    pcs: "개",
    totalCartons: "총 카톤 수",
    createCartonFirstScanning: "스캔을 시작하려면 먼저 카톤을 생성하세요",
    orderInformation: "주문 정보",
    tracking: "운송장 번호",
    orderItems: "주문 품목",
    complete: "완료",
    cartonManagement: "카톤 관리",
    cartonDetails: "카톤 상세 정보",
    cartonSize: "카톤 크기",
    extraInformation: "추가 정보",
    itemsInCarton: "카톤 내 품목",
    noItemsScanned: "아직 스캔된 품목이 없습니다",
    materialsInCarton: "카톤 내 자재",
    noMaterialsScanned: "아직 스캔된 자재가 없습니다",
    packingSummary: "포장 요약",
    totalOrders: "총 주문 수",
    totalSKUs: "총 SKU 수",
    totalPacked: "총 포장 수",
    scanTraceIdHere:"여기서 순환박스를 스캔합니다",
    traceIdScanMode:"순환박스 스캔 모드",
    cm: "센티미터",
    kg: "킬로그램",
    isFarfetchReturnRefundShippingCost:"파페치는 반품 시 배송비를 환불해 주나요?",
    dontInputSkuScanBarcode:"SKU를 입력하지 마세요. 바코드를 스캔하세요.",
    innerQtyMustEqualPackQty:"내대 자재 수량은 포장 수량과 같아야 합니다",
    outerQtyAtLeastOne:"외포장 자재는 최소 1개 이상이 필요합니다",
    projectQueryList:"프로젝트 검색 목록",
    defaultQueryList:"기본 검색 목록",
    hide:"숨기기",
    show:"보이기",
    copyToProjectList:"프로젝트 목록에 복사",
    copyToAnotherLanguage:"복사하여 다른 언어로 붙여넣기",
    copyToAnotherProject:"복사하여 다른 프로젝트로 이동",
    copyTo:"~에 복사하다",
    DueDateUpdateConfirm:"아래 웨이브에는 이미 스캔 팩 마감일이 포함되어 있습니다. 업데이트를 확인하시겠습니까?",
    domain:"도메인",
    singleSignOn:"싱글 사인 온",
    countedQty:"재고조사 수량",
    packFactor:"포장 계수",
    importMsg:"임포트 메시지",
    uploadTime:"업로드 시간",
    AreYouImportTask: "선택한 레코드를 임포트하시겠습니까?",
    countDateFrom:"재고조사 시작일",
    countDateTo:"재고조사 종료일",
    selectOfflineCountResult:"오프라인 재고조사 결과 선택",
    po:"구매 주문",
}
